<template>
  <iframe ref="wujie" class="iframe" :src="url" :key="key" />
</template>

<script>
import searchCondition from '@/assets/js/search_condition.js'
export default {
  name: 'wujie',
  props: ['type'],
  data: () => {
    return {
      active: false,
      url: '',
      key: '',
      oldType: '',
    }
  },
  activated() {
    this.active = true
    this.url = this.getUrl()
    window.top.addEventListener('message', this.parseMessage, false)
  },
  deactivated() {
    this.active = false
    window.top.removeEventListener('message', this.parseMessage, false)
  },
  watch: {
    $route(to, from) {
      if(this.active) {
        if(this.oldType != this.type || this.type == 'pda') {
          this.oldType = this.type
          const url = this.getUrl()
          if(url) {
            this.url = url
            this.key = new Date().getTime()
          }
        } else {
          this.$refs.wujie.contentWindow.postMessage({type: 'redirect', path: this.$route.path, query: this.$route.query}, '*')
        }
      }
    }
  },
  methods: {
    isDev() {
      return process.env.NODE_ENV == "development"
    },
    getBaseURL() {
      // switch(this.type) {
      //   case 'cockpit'  : return this.isDev() ? 'http://127.0.0.1:5173/#' : 'https://ckpt.51homemoney.com/dist/#'
      //   case 'office'   : return this.isDev() ? 'http://localhost:3000/#' : 'https://office.gdzawy.com:9001/#'
      //   case 'pda'      : return this.isDev() ? 'http://pda.local.com' : 'https://pda.51homemoney.com'
      //   case 'school'   : return this.isDev() ? 'http://localhost:3000/#' : 'https://engineering.gdzawy.com:9001/admin/#'
      //   case 'secp'     : return this.isDev() ? 'http://localhost:3000/#' : 'https://engineering.gdzawy.com:9001/admin/#'
      //   case 'quality'  : return this.isDev() ? 'http://localhost:3000/#' : 'https://quality.gdzawy.com:9001/dist/#'
      //   case 'hr'       : return this.isDev() ? 'http://localhost:3000/#' : 'https://flow.gdzawy.com:9001/hr-dist/#'
      //   case 'budget'   : return this.isDev() ? 'http://localhost:3000/#' : 'https://budget.gdzawy.com:9001/hr-dist/#'
      // }
      switch(this.type) {
        case 'cockpit'  : return this.isDev() ? window.Glob.cockpit : window.Glob.cockpitApi
        case 'office'   : return this.isDev() ? window.Glob.office : window.Glob.officeApi
        case 'pda'      : return this.isDev() ? window.Glob.pda : window.Glob.pdaApi
        case 'school'   : return this.isDev() ? window.Glob.hr : window.Glob.schoolApi
        case 'secp'     : return this.isDev() ? window.Glob.hr : window.Glob.secpApi
        case 'quality'  : return this.isDev() ? window.Glob.hr : window.Glob.qualityApi
        case 'hr'       : return this.isDev() ? window.Glob.hr : window.Glob.hrApi
        case 'budget'   : return this.isDev() ? window.Glob.hr : window.Glob.budgetApi
        case 'agreement'   : return this.isDev() ? window.Glob.agreement : window.Glob.agreementApi
      }
    },
    getUrl() {
      const path = this.$route.fullPath
      let url = ''
      if(this.type == 'pda') {
        const route = path.replace('/pda', '')
        url = this.getBaseURL() + '/admin' + route + (route.indexOf('?') == -1 ? '?' : '&') + 'from=zhongtai'
      } else {
        url = this.getBaseURL() + path
      }
      return url + (url.indexOf('?') == -1 ? '?' : '&') + 'login=' + localStorage.getItem('login') + '&token=' + localStorage.getItem('token')
    },
    parseMessage(e) {
      const data = e.data

      // 跳转
      if(data.action == 'erp-redirect') {
        let query = {}
        if(data.query) {
          for(let k in data.query) {
            if(['login', 'token', '_redirect'].includes(k) == false) query[k] = data.query[k]
          }
        }
        // console.log(this.$route.query, data.query)
        // if(this.$route.path !== data.path) {
        //   query._redirect = data.query._redirect && data.query._redirect == 1 ? 1 : 0
        //   this.$router.push({path: data.path, query: query})
        // }
        //query._redirect = data.query._redirect && data.query._redirect == 1 ? 1 : 0
        this.$router.push({path: data.path, query: query})
      }

      // 缓存搜索条件
      else if (data.action == 'search-condition-get') {
        searchCondition.getFromIframe(this.$refs.wujie)
      }
      else if (data.action == 'search-condition-set') {
        searchCondition.set(data.data)
      }

    }
  }
}

</script>

<style lang="scss" scoped>
  .iframe {
    flex: 1;
    border: none;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/wujie.vue